var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCartinline = function SvgCartinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 1a1 1 0 0 0 0 2c1.418 0 1.927.885 2.023 1.218L5.802 14H5.23c-1.02 0-1.944.221-2.637.745C1.863 15.297 1.5 16.103 1.5 17c0 .897.364 1.703 1.093 2.255.693.524 1.617.745 2.637.745h1.82a2.499 2.499 0 1 0 4.9 0h5.1a2.503 2.503 0 0 0 .682 2.268A2.5 2.5 0 1 0 19.5 18H5.23c-.764 0-1.205-.17-1.43-.34-.19-.144-.3-.338-.3-.66s.11-.516.3-.66c.225-.17.666-.34 1.43-.34H20a1 1 0 0 0 .984-.821l2-11A1 1 0 0 0 22 3H5.66C5.13 2.052 3.983 1 2 1Zm17.5 19a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Zm-10 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Zm-1.665-6L6.198 5h14.604l-1.637 9H7.835Z",
    fill: "#4A4A4A"
  })));
};
export default SvgCartinline;